import axios from '@/config/httpConfig'

// 知识文章 版本列表
export function queryArticleVersionList(data) {
    return axios.post("/knowledgeArticleOperate/queryArticleVersionList", data);
}